import styled from 'styled-components';

const RemoveMessageModalWrapper = styled.div`
  width: 368px;
  .confirmation-button {
    background-color: ${({ theme }) => theme.colors.danger[600]};
  }
`;

export default RemoveMessageModalWrapper;
